
export const presetUserId = (userId: string, presetId: string) => userId + "-" + presetId;
